module.exports = __webpack_public_path__ + "img/icon_whatsapp_white.5dd32ab.svg";